class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // DTC opens the desktop menu on hover; touch and keyboard keep Dawn's click/Enter toggle.
    this.hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.addEventListener('mouseenter', () => this.onHover(true));
    this.addEventListener('mouseleave', () => this.onHover(false));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
      if (this.openedByHover) event.preventDefault();
    });
  }

  onHover(entering) {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.hoverCloseTimer);

    if (entering) {
      this.openedByHover = true;
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    } else {
      // Grace period so a diagonal move from the nav item into the panel doesn't close it.
      this.hoverCloseTimer = setTimeout(() => this.close(), 150);
    }
  }

  close() {
    this.openedByHover = false;
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
